export enum EntityTypes {
  Body = 'Body',
  Section = 'Section',
  Column = 'Column',
  Image = 'Image',
  Text = 'Text',
  Button = 'Button',
  HorizontalLine = 'HorizontalLine',
}
